import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Loading from "../../views/Loading";
import { Grid, Col, Row, Button } from "react-bootstrap";
import moment from "moment";
import Card from "../Card/Card";
import { data_consumo_materia_prima, options_Months, data_year, responsiveBar, } from "../../variables/constantes";
import JqxGrid/*, { jqx }*/ from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { rutas } from "../../routes_backend/routes";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import CanvasJSReact from "../utils/pareto_chart/canvasjs.react.js";
import { ExcelReporte } from "../../components/utils/Excel_produccion";

// const CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
// CanvasJS.addColorSet("customColorSet1", [
//   //colorSet Array
//   "#2576d5",
//   "#a4403d",
//   "#839f48",
//   "#ffa338",
//   "#C0C0C0",
//   "#808000",
//   "#008080",
//   "#FF00FF",
//   "#2BCCBF",
//   "#00FF00",
//   "#000080"
// ]);
 const myGrid = React.createRef();
class headcount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPlantas: data_consumo_materia_prima,
      is_description: "All",
      message: "",
      dataMonth: options_Months,
      is_month: moment().format("M"),
      isLoading: false,
      data: [],
      chartPlantas: [],
      NumeroMes: [],
      from_Year: moment().format("YYYY"),
      to_Year: moment().format("YYYY"),
      itemYear: data_year,
      dataP: [],

       //-------------------- tabla detalle -----------------------
       columns_detalle: [
        { text: 'Area', datafield: 'CentroCostos', align: 'center', cellsalign: 'center', width: "50%" },
        { text: 'Conteo', datafield: 'Conteo', align: 'center', cellsalign: 'center', width: "50%",  aggregates: ["sum"], },
        
      ],

      sourceTable: [],
      dataGraphicMonth: [],
      dataGraphicArticle: [],
      dataGraphicPlantas: [],
      dataGraphicArea: [],
      dataGraphicElemento: [],
      plantaSelect: "",
      is_month_temp: '',
      is_planta_temp: ''
    };
  }
  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  
  componentWillMount() {
    this.data();
  }
  clear = () => {
    this.setState({
      
      dataGraphicMonth: [],
      dataGraphicArticle: [],
      
    });
  };
  refreshPage() {
    window.location.reload(false);
  }
  data = () => {
    try {
      this.setState({
        isLoading: true,
        data: [],
        sourceTable: [],
        dataGraphicMonth: [],
        dataGraphicArticle: [],
        dataGraphicPlantas: [],
        dataGraphicArea: [],
        dataGraphicElemento: [],
        plantaSelect: "",
      });
      //----------------------------------------- consulta backend ------------------------------------------------------      
      let source_print = [];
      let url = `${rutas.get_headcount_primera}`;
      fetch(url)
        .then(async (res) => {                 
          let data = await res.json();
          let dataDetalleD = data
          let arrayD = []
            dataDetalleD.forEach(element => {
                
              let arrD = [
                element.CentroCostos,
                element.Conteo,
               
              ]
              arrayD.push(arrD)
               source_print.push(arrD);
            });
            // console.log(dataDetalleD) 
            let temp_source_dipsonibilidad_planta_detalle = {
              //dataDetalleGrafica: [],
              localdata: arrayD,
              datafields: [
                { name: 'CentroCostos', type: 'string', map: '0' },
                { name: 'Conteo', type: 'string', map: '1' },
                
              ],
              datatype: 'arrayD',
            };
          // console.log(data)
          var groupByPlanta = function (miarray, prop) {
            return miarray.reduce(function (groups, item) {
              var val = item[prop];
              groups[val] = groups[val] || {
                y: item.Conteo,
                label: item.CentroCostos,
                // NMes: item.CentroCostos,
              };
              return groups;
            }, {});
          };
          let array = []
          let arraygrafica = []
          data.forEach(element => {
            let arr = [
              element.Conteo,
            ]
            let obj = {
              Conteo: element.Conteo,
              CentroCostos: element.CentroCostos,
              // order: element.Conteo,
              // NMes: element.NMes,
            }
            array.push(arr)
            arraygrafica.push(obj)
          });
          arraygrafica.sort(function (a, b) {
            if (a.NMes > b.NMes) {
              return 1;
            }
            if (a.NMes < b.NMes) {
              return 1;
            }
            return 0;
          });
          //------------------------------ grafica master --------------------------------------------
          var data_Group_planta = groupByPlanta(arraygrafica, "Conteo");
          let dataPlantaGroup = Object.values(data_Group_planta);

          const optionsPlantas = {
            exportEnabled: true,
            animationDuration: 400,
            animationEnabled: true,
            interactivityEnabled: true,
            // zoomEnabled: false,
            // colorSet: "customColorSet1",

            // toolTip:{
            //   enabled: true,       //disable here
            //   animationEnabled: true //disable here
            // },

            title: {
              text: "HEADCOUNT",
            },
            data: [
              {
                type: "pie",
                indexLabelMaxWidth: 100,
                toolTipContent: "<b>{label}: Conteo </b>: {y}",

                indexLabelFontSize: 16,
                showInLegend: "true",
				       legendText: "{label}",
                indexLabel: "{y}",
                click: this.chartPlantas,

                dataPoints: dataPlantaGroup,
              },
            ],
          };

          this.setState({
            isLoading: false,
            message: "",
            sourceTablaDetalle: temp_source_dipsonibilidad_planta_detalle,
            // sourceTable: new jqx.dataAdapter(source_temp),
            data: data,
            data1: arraygrafica,
            dataGraphicPlantas: optionsPlantas,
            data_excel: source_print,
          });
        })

        .catch((error) => {
          console.log(error);
          this.setState({
            message: "error in server",
            isLoading: false,
          });
        });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
    }
  };
  // //------------------------------------- boton excel --------------------------------------- 
  excelBtnOnClick = () => {
    // const { sourceTable } = this.state;

    let name = "Headcount Detalle";
    let columns = [
      { Header: "Area" },
      { Header: "Conteo" },
      

    ];
    // let data_print = sourceTable.originaldata;
    ExcelReporte(this.state.data_excel, columns, name);
  };

  chartPlantas = (event) => {
    const {  data1 } = this.state;
    let arr = [];
    data1.forEach((element) => {
      if (element.CentroCostos === event.dataPoint.label) {
       
        arr.push(element);
        // console.log(element);
        let url = `${rutas.get_LugarTrabajoHeadCount}?lugarT=${element.CentroCostos}`;
        fetch(url)
          .then(async (res) => {
            let dataP = await res.json();
            // console.log(dataP)
            var dataPlantaGroup = []
            dataP.forEach(item => {
              let arrD = {
                label: item.LugarTrabajo,
                y: item.Conteo,
                LugarTrabajoTemp: item.LugarTrabajo
              }
              dataPlantaGroup.push(arrD)
            });        

            const optionsMes = {
              exportEnabled: true,
              animationEnabled: true,
              // colorSet: "customColorSet1",
              title: {
                text: "Conteo por Lugar de Trabajo "
                
              },
              data: [
                {
                  type: "column",
                  indexLabelMaxWidth: 100,
                  toolTipContent: "<b>Area: {label}: Conteo </b>: {y}",
                  indexLabelFontSize: 16,
                  indexLabel: "{y}",
                  click: this.chartItem,
                  //click: this.FallaTMArea,                
                  dataPoints: dataPlantaGroup,
                  is_month_temp: element.LugarTrabajo
                },
              ],
            };
            // --------------- fin propiedades de la grafica disponibilidad por planta --------------

            this.setState({
              dataGraphicMonth: optionsMes,
              plantaSelect: event.dataPoint.label,
              dataP: dataP,
              is_month_temp: element.LugarTrabajo

            });
          })
        //------------------------------------------------------------------------------
      }
    }
    );

  };

  chartItem = (event) => {
    const { dataP } = this.state;

    let arr = [];
    dataP.forEach((element) => {
      if (element.LugarTrabajo === event.dataPoint.label) {
        arr.push(element);
        //  console.log("AREA TRABAJO ", element.LugarTrabajo);
        //  console.log("LUGAR TRABAJO ", element.CentroCostos);
        let url3 = `${rutas.get_AreaLaboralHeadCount}?areaL=${element.LugarTrabajo}&lugarT=${element.CentroCostos}`;
            // console.log(url3)
        fetch(url3)

          .then(async (res) => {
            let data = await res.json();

          //   var groupByPlanta = function (miarray, prop) {
          //     return miarray.reduce(function (groups, item) {
          //       var val = item[prop];
          //       groups[val] = groups[val] || {
          //         label: item.AreaLaboral,
          //         y: item.Conteo,
          //       };
          //       return groups;
          //     }, {});
          //   };
          //    //------ coloca nombre del mes dependiendo del NMes --------------
          let array = []
          let arraygrafica = []
          data.forEach(item => {
            let arr = {
              label: item.AreaLaboral,
              y: item.Conteo
              
            }
            let obj = {
              // Mes: get_Month_Name(element.NMes),
              AreaLaboral: element.AreaLaboral,
              Conteo: element.Conteo,
              // NMes: element.NMes,
            }
            array.push(arr)
            arraygrafica.push(obj)
          });
          // arraygrafica.sort(function (a, b) {
          //   if (a.NMes > b.NMes) {
          //     return 1;
          //   }
          //   if (a.NMes < b.NMes) {
          //     return 1;
          //   }
          //   return 0;
          // });
          // //------ fin coloca nombre del mes dependiendo del NMes --------------

          //   var data_Group_planta = groupByPlanta(arraygrafica, "Conteo");
          //   let dataPlantaGroup = Object.values(data_Group_planta);

            // ------------------ propiedades de la grafica disponibilidad por planta --------------

            const optionsArticle = {
              exportEnabled: true,
              animationEnabled: true,
              // colorSet: "customColorSet1",
              title: {
                text: "Conteo por planta seleccionada",
              },
              data: [
                {
                  type: "column",
                  indexLabelMaxWidth: 100,
                  toolTipContent: "<b>Area: {label} - Conteo </b>: {y}",
                  indexLabelFontSize: 16,
                  indexLabel: "{y}",
                  dataPoints: array,
                },
              ],
            };
            // --------------- fin propiedades de la grafica disponibilidad por planta --------------

            this.setState({
              dataGraphicArticle: optionsArticle,
              plantaSelect: event.dataPoint.label,

            });
          })
      }
    });
  };
  // -------------------------------------- render ---------------------------------------- 
  render() {
    const {
      isLoading,
    } = this.state;
    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                // title="HEADCOUNT"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="m">
                    
                    </div>
                    <div className="col-sm-12">
                    
               
                      {/*----------------------------- grafica maestra por plantas -------------------------------  */}
                      {this.state.dataGraphicPlantas ? (
                        <div className="m">
                          <br />
                          <br />
                          <div className="col-sm-6">
                            <CanvasJSChart
                              options={this.state.dataGraphicPlantas}
                              responsive={responsiveBar}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                     {/* ----------------------- Grid tabla disponibilidad detalle -------------------- */}

                     {!_.isEmpty(this.state.sourceTablaDetalle) ? (
                        <div className="m">
                          

                          <div className="col-sm-6">
                            <b>HEADCOUNT DETALLE</b>
                            <JqxGrid
                              width={"100%"}
                              height={"328px"}
                              columns={this.state.columns_detalle}
                              source={this.state.sourceTablaDetalle}
                              showaggregates={true}
                              enabletooltips={true}
                              columnsresize={true}
                              showtoolbar={true}
                              theme={"material"}
                              showstatusbar={true}
                              ref={myGrid}
                              filterable={true}
                              // groupable={true}
                              showgroupaggregates={true}
                              statusbarheight={25}
                              sortable={true}
                            />
                            <br />
                            <Button
                                onClick={this.excelBtnOnClick}
                                bsStyle="primary"
                                active
                              >
                                <i className="pe-7s-print" />
                                Download Excel.
                              </Button>
                          </div>
                          <br />
                          <br />
                          <center>
                            <br />
                            <div>
                              <br />
                              <br />
                              {/* <Button
                                // onClick={this.excelBtnOnClick}
                                bsStyle="primary"
                                active
                              >
                                <i className="pe-7s-print" />
                                Download Excel.
                              </Button> */}
                            </div>
                          </center>
                        </div>
                      ) : (
                        ""
                      )}
                      <Button
                          onClick={this.refreshPage}
                          bsStyle="danger"
                          bsSize="small"
                          active
                        >
                          Limpiar
                        </Button>
                      <div>
                      <div className="m">
                      
                        </div>
                      </div>
                      
                      {/*----------------------------- segunda grafica -------------------------------  */}
                      {this.state.dataGraphicMonth ? (
                        
                        <div className="m">
                         
                          <div className="col-sm-12">
                            <CanvasJSChart
                              options={this.state.dataGraphicMonth}
                              responsive={responsiveBar}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div>
                          <div className="m">
                            <br />
                            <br />
                            {/*----------------------------- tercer grafica -------------------------------  */}
                            {this.state.dataGraphicArticle ? (
                              <div className="m">
                                <br />
                                <br />
                                <div className="col-sm-12">
                                  <CanvasJSChart
                                    options={this.state.dataGraphicArticle}
                                    responsive={responsiveBar}
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(headcount);
// const style = {
//   text: {
//     textAlign: "center",
//   },

//   errorMessage: {
//     fontWeight: "bold",
//     fontSize: "12px",
//     height: "10px",
//     color: "red",
//   },
// };
